import React, { Component } from 'react';

import './Everify.scss';

import Countdown from './Countdown';
import {
  STEP_BANK_FAILURE,
  STEP_BANK_STATUS_FAILURE,
  STEP_BANK_SUCCESS,
  STEP_MANUAL,
  TECHNICAL_BANK_FAILURE,
  EVY_TIME_OUT,
} from '../AddBank/AddBank';
import config from '../../../config/config';
import If from '../../Shared/If/If';
import FullPageLoader from 'src/components/Shared/FullPageLoader/FullPageLoader';
import { buildNewManualBank } from '../../../utils/banking/bank-utils';
import { createNameObject } from '../../../utils/utils';
import { EVERIFY_FAILURES } from '../../../settings/settings';
import { dispatchPageLoad } from '../../../redux/utils/analytics-helper';
export class Everify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verified: false,
      timeRemaining: 180,
      countdownStatus: 'PRE',
      timerId: null,
      evLoaded: false,
      evSubmitted: false,
    };
    this.clearAllTimers = this.clearAllTimers.bind(this);
    this.sendBankInformation = this.sendBankInformation.bind(this);
    this.decrement = this.decrement.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleFrameTasks = this.handleFrameTasks.bind(this);
    this.timerId = null;
    this.pollId = null;
    this.timer = null;
  }

  componentDidMount() {
    const {
      actions: { checkStatus },
      eVerification: {
        trackingid,
        manualBankAccountType,
        manualBankRoutingNumber,
        manualBankAccountNumber,
        manualBankJointOwnerFirstName,
        manualBankJointOwnerLastName,
      },
    } = this.props;
    const { countdownStatus } = this.state;
    checkStatus(
      manualBankAccountType,
      manualBankRoutingNumber,
      manualBankAccountNumber,
      trackingid,
      createNameObject(
        manualBankJointOwnerFirstName,
        manualBankJointOwnerLastName
      )
    );
    dispatchPageLoad('ThirdPartyManual');
    window.addEventListener('message', this.handleFrameTasks, true);
    setTimeout(() => {
      this.timer = setInterval(
        () =>
          (countdownStatus === 'INIT' || countdownStatus === 'PRE') &&
          this.decrement(),
        1000
      );
      this.setState({
        countdownStatus: 'INIT',
      });
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }

  componentDidUpdate(prevProps) {
    this.checkBankStatus(prevProps);
    this.checkBankFailed(prevProps);
    this.checkBankSuccess(prevProps);
  }

  checkBankStatus(prevProps) {
    const {
      actions: { createEverify },
      eVerification: {
        checkStatusLoaded,
        checkStatusFailed,
        verifiedBank,
        bankAwaitingVerification,
        manualBankSimulationMode,
      },
      setBankProgress,
    } = this.props;

    const {
      eVerification: { checkStatusLoading: prevCheckStatusLoading },
    } = prevProps;

    if (prevCheckStatusLoading && checkStatusLoaded) {
      if (checkStatusFailed) {
        setBankProgress(TECHNICAL_BANK_FAILURE);
      } else if (bankAwaitingVerification || verifiedBank) {
        setBankProgress(STEP_BANK_STATUS_FAILURE);
      } else {
        createEverify(manualBankSimulationMode);
      }
    }
  }

  sendBankInformation(token) {
    const {
      actions: { addBank },
      eVerification: {
        manualBankAccountType,
        manualBankRoutingNumber,
        manualBankAccountNumber,
        manualBankJointOwnerFirstName,
        manualBankJointOwnerLastName,
      },
    } = this.props;
    // returning undefined is okay here because our add bank call will check for undefined
    addBank(
      manualBankAccountType,
      manualBankRoutingNumber,
      manualBankAccountNumber,
      token,
      createNameObject(
        manualBankJointOwnerFirstName,
        manualBankJointOwnerLastName
      ) /* according to business rules we're intentionally not including suffix */
    );
  }

  checkOrigin(event) {
    return (
      event.origin.includes(`troweprice.com`) ||
      event.origin.includes(`awstrp.net`)
    );
  }

  checkEvSubmitted(event, evSubmitted) {
    return event.data.messageType === 'failure' && !evSubmitted;
  }

  handleFrameTasks(event) {
    const {
      actions: { incrementEverifyAttempts, resetEverify },
      eVerification: { trackingid, addBankLoading, evrFailed },
      setBankProgress,
      handleClose,
      isSalesforceRep,
      customerWebViewEnabled,
    } = this.props;
    const { evSubmitted, evLoaded } = this.state;

    if (evrFailed) {
      resetEverify();
      setBankProgress(TECHNICAL_BANK_FAILURE);
    }

    if (!this.checkOrigin(event)) {
      return;
    }
    if (
      event.data.messageType === 'success' &&
      !evSubmitted &&
      !addBankLoading
    ) {
      this.setState({
        evSubmitted: true,
      });
      this.sendBankInformation(trackingid);
    } else if (this.checkEvSubmitted(event, evSubmitted)) {
      this.setState({
        evSubmitted: true,
      });
      if (event.data.reason === 'cancelled') {
        if (!(!customerWebViewEnabled && isSalesforceRep)) {
          handleClose();
        } else {
          setBankProgress(STEP_MANUAL);
        }
      } else if (evLoaded) {
        incrementEverifyAttempts();
        this.sendBankInformation(trackingid);
        setBankProgress(STEP_BANK_FAILURE);
      } else if (!evSubmitted) {
        setBankProgress(TECHNICAL_BANK_FAILURE);
      }
    } else if (event.data.messageType === 'loaded') {
      this.setState({
        evLoaded: true,
      });
    }
  }

  isEverifyFailure(resultType) {
    return EVERIFY_FAILURES[resultType] ? true : false;
  }

  checkBankFailed(prevProps) {
    const {
      eVerification: { addBankLoaded, addBankFailed, addBankStatus },
      setBankProgress,
    } = this.props;

    const {
      eVerification: { addBankLoading: prevAddBankLoading },
    } = prevProps;

    if (
      prevAddBankLoading &&
      addBankLoaded &&
      (addBankFailed || addBankStatus !== 'SUCCESS')
    ) {
      // if add bank call were to fail need to kill flow
      setBankProgress(STEP_BANK_FAILURE);
    }
  }

  checkBankSuccess(prevProps) {
    const {
      actions: { getExistingBanks, getBankMaps, registerNewBank },
      dispatch,
      eVerification,
      eVerification: { addBankLoaded, addBankStatus },
      setBankProgress,
    } = this.props;

    const {
      eVerification: { addBankLoading: prevAddBankLoading },
    } = prevProps;

    if (prevAddBankLoading && addBankLoaded && addBankStatus === 'SUCCESS') {
      const bank = buildNewManualBank(eVerification);
      registerNewBank(bank, getExistingBanks);
      dispatch(getBankMaps());
      setBankProgress(STEP_BANK_SUCCESS);
    }
  }

  clearAllTimers() {
    clearTimeout(this.timerId);
    clearInterval(this.timer);
  }

  decrement() {
    const { setBankProgress } = this.props;
    const { timeRemaining } = this.state;
    if (timeRemaining > 0) {
      this.setState({ timeRemaining: this.state.timeRemaining - 1 });
    } else if (timeRemaining <= 0) {
      this.setState({ countdownStatus: 'COMPLETE' });
      this.clearAllTimers();
      setBankProgress(EVY_TIME_OUT);
    }
  }

  onSubmit() {
    this.setState({ countdownStatus: 'POST' });
  }

  render() {
    const {
      eVerification: { addBankLoading, evyReady },
      inTest = false,
    } = this.props;
    const { timeRemaining, evLoaded } = this.state;
    return (
      <div className="everify-container">
        <h1 className="everify-header">
          Help us verify ownership of your account
        </h1>
        <If test={!evyReady || addBankLoading || !evLoaded}>
          <div className="everify-loader-container">
            <FullPageLoader isVisible={true} />
          </div>
        </If>
        {((evyReady && !addBankLoading) || inTest) && (
          <>
            <div className="everify-frame-container">
              <iframe
                id="evIfrm"
                className="everify-frame"
                name="evIfrm"
                title="evIfrm"
                src={`${config.url}/evy-static/index.html`}
              />
            </div>
          </>
        )}
        <If test={(evyReady && !addBankLoading && evLoaded) || inTest}>
          {' '}
          {/* must be separate if to avoid extra markup */}
          <Countdown
            className="countdown-timer"
            currentTime={timeRemaining}
            isWarningPeriod={timeRemaining <= 60}
          />
        </If>
      </div>
    );
  }
}

export default Everify;
